import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";

const ImageWithLoader = ({ src, alt }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setLoading(false);
    img.onerror = () => {
      setLoading(false);
    };
  }, [src]);

  return (
    <div className="relative w-full h-60 flex items-center justify-center">
      {loading && <CircularProgress className="absolute" />}
      <div
        className={`bg-center md:bg-contain bg-cover bg-repeat-x transition-opacity duration-1000 ${
          loading ? "opacity-0" : "opacity-100"
        }`}
        style={{
          backgroundImage: `url(${src})`,
          height: "100%",
          width: "100%",
        }}
      />
    </div>
  );
};

export default ImageWithLoader;
